import { ReducerDataState } from 'shared/interface/globalInterface';
import { DetailsDataStructure } from 'components/DetailsPageBoilerplate/types';
import { FirmDetailsResponseData, ClubDetailsResponseData, NetworkDetailsResponseData } from 'utils/api/types';

export type ResponseData<T = FirmDetailsResponseData | ClubDetailsResponseData | NetworkDetailsResponseData> = {
  resources: any;
  data: T;
};
export type State<T> = ReducerDataState<Details | T>;
export type Details = DetailsDataStructure;
export type Error = string;

export const ACTION_TYPES = {
  PENDING: 'DETAILS/FETCH/PENDING',
  ERROR: 'DETAILS/FETCH/ERROR',
  SUCCESS: 'DETAILS/FETCH/SUCCESS',
  RESET: 'DETAILS/RESET',
  REMOVE_ADMIN: 'REMOVE_ADMIN',
};
